<template>
    <div v-if="loading"></div>
    <div v-else>
        <TcmHome :cdutcm-portal-config="cdutcmPortalConfig" v-if="cdutcmPortalConfig.enabled"></TcmHome>
        <Home v-else></Home>
    </div>
</template>

<script>
import Home from "@/views/home/Home.vue";
import TcmHome from "@/views/home/TcmHome.vue";
import Vue from "vue";

import { createNamespacedHelpers } from "vuex";

const { mapGetters, mapActions } = createNamespacedHelpers("config");

export default Vue.extend({
    name: "Index",
    components: { Home, TcmHome },
    data() {
        return {
            loading: true
        };
    },
    computed: {
        localePrefix() {
            return this.$i18n.locale.split("-")[0];
        },
        ...mapGetters(["cdutcmPortalConfig"])
    },
    methods: {
        ...mapActions(["getCdutcmPortalConfig"])
    },
    async created() {
        await this.getCdutcmPortalConfig();
        this.loading = false;
    }
});
</script>
